var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "prohibited",
  "use": "prohibited-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 9\" id=\"prohibited\"><path d=\"M4.5 0a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 1a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7\" /><path d=\"m2.025 1.318 5.657 5.657-.707.707-5.657-5.657z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol